import { getAuth, isAuthenticated } from '@services/identity.service';
import { isAdminRoute, isProtected, guestModeAllowed, isCopilotRoute } from '@lib/security';
import { useIsFirstRender } from '@uidotdev/usehooks';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

const isBrowser = () => typeof window !== 'undefined';

const WithAuth = ({ router, children }) => {
  const auth = getAuth();
  const posthog = usePostHog();
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    if (!isFirstRender) return;

    if (!isAuthenticated(auth)) return;

    posthog?.capture('Logged In');
  }, [isFirstRender]);

  if (['development', 'sandbox', 'qa1'].includes(process.env.NEXT_PUBLIC_APP_ENV) && router.pathname.includes('sandbox')) {
    return children;
  }

  if (auth && auth.userRole === 'guest' && guestModeAllowed(router.pathname)) {
    return children;
  }

  if (auth && auth.userRole === 'copilot' && isCopilotRoute(router.pathname)) {
    return children;
  }

  if (process.env.NEXT_PUBLIC_APP_ENV === 'sandbox' && !router.pathname.includes('/sandbox')) {
    router.replace('/sandbox');
  }
  if (isBrowser() && !isAuthenticated(auth) && isProtected(router.pathname)) {
    router.replace({ pathname: '/login', query: { next: router.pathname, ...router.query } });
  }
  if (auth && isAdminRoute(router.pathname) && auth.userRole !== 'admin') {
    router.replace('/landing');
  }
  return children;
};

export default WithAuth;
